module.exports = "﻿﻿<h1 mat-dialog-title>Help Information</h1>\r\n<mat-dialog-content class=\"mat-typography\">\r\n    <div [innerHtml]=\"htmlContent\"></div>\r\n</mat-dialog-content>\r\n<mat-dialog-actions align=\"end\">\r\n    <button mat-button mat-dialog-close>Cancel</button>\r\n</mat-dialog-actions>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/navigation/help.dialog.component.html
// module id = 1531
// module chunks = 0